"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _roarr = _interopRequireDefault(require("roarr"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = _roarr.default.child({
  package: 'extract-date'
});

exports.default = _default;
//# sourceMappingURL=Logger.js.map